// extracted by mini-css-extract-plugin
export var chevronIcon = "_sa-1";
export var edgeToggle = "_sa-0";